(() => {
  'use strict';
  const widget = document.querySelector('[data-vt-currency]');
  if (!widget) return;
  const select = widget.querySelector('select');
  const status = widget.querySelector('[role="status"]');
  const lt = document.documentElement.lang.startsWith('lt');
  const currencies = [...select.options].map(option => option.value);
  const originals = new WeakMap();
  const day = 86400000;
  let selected = 'EUR', rates = null, request = null, version = 0;
  function storage(type, action, key, value) {
    try { return window[type][action](key, value); } catch (_) { return null; }
  }
  function valid(data) {
    return data && Number.isFinite(data.fetched) && Date.now() >= data.fetched && Date.now() - data.fetched < day &&
      Array.isArray(data.rows) && currencies.filter(code => code !== 'EUR').every(code => {
        const row = data.rows.find(item => item.quote === code);
        const age = Date.now() - Date.parse(row?.date + 'T00:00:00Z');
        return row?.base === 'EUR' && Number.isFinite(row.rate) && row.rate > 0 && age >= -day && age < 7 * day;
      });
  }
  async function loadRates() {
    if (rates && valid(rates)) return rates;
    try { const cached = JSON.parse(storage('sessionStorage', 'getItem', 'vt-display-rates')); if (valid(cached)) return (rates = cached); } catch (_) { /* Fetch a fresh quote. */ }
    if (request) return request;
    request = (async () => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 7000);
      try {
        const response = await fetch('https://api.frankfurter.dev/v2/rates?base=EUR&quotes=' + currencies.filter(code => code !== 'EUR').join(',') + '&providers=ECB', { signal: controller.signal, credentials: 'omit', referrerPolicy: 'no-referrer' });
        if (!response.ok) throw new Error('Rates unavailable');
        const data = { fetched: Date.now(), rows: await response.json() };
        if (!valid(data)) throw new Error('Invalid or stale rates');
        rates = data;
        storage('sessionStorage', 'setItem', 'vt-display-rates', JSON.stringify(data));
        return data;
      } finally { clearTimeout(timer); }
    })().finally(() => { request = null; });
    return request;
  }
  function render() {
    if (selected !== 'EUR' && !valid(rates)) {
      selected = 'EUR'; select.value = 'EUR';
      status.textContent = lt ? 'Atnaujinkite valiutos kursą. Kainos rodomos EUR.' : 'Please refresh the conversion rate. Prices shown in EUR.';
      storage('sessionStorage', 'setItem', 'vt-display-currency', 'EUR');
    }
    const rate = selected === 'EUR' ? 1 : rates?.rows.find(row => row.quote === selected)?.rate;
    if (!rate) return;
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: selected, currencyDisplay: 'code' });
    document.querySelectorAll('[data-vt-eur-cents]').forEach(node => {
      const cents = Number(node.dataset.vtEurCents);
      if (!Number.isFinite(cents) || node.dataset.vtEurCents.trim() === '') return;
      if (!originals.has(node)) originals.set(node, node.innerHTML);
      if (selected === 'EUR') {
        const original = originals.get(node);
        if (node.innerHTML !== original) node.innerHTML = original;
        node.removeAttribute('data-vt-converted');
        node.removeAttribute('title');
      } else {
        const label = '≈ ' + formatter.format(cents / 100 * rate);
        if (node.textContent !== label) node.textContent = label;
        node.dataset.vtConverted = selected;
        node.title = new Intl.NumberFormat('en', {style:'currency', currency:'EUR', currencyDisplay:'code'}).format(cents / 100);
      }
    });
  }
  async function change(code, remember = false) {
    const current = ++version;
    if (!currencies.includes(code)) code = 'EUR';
    if (code === 'EUR') {
      selected = code; select.value = code; status.textContent = ''; render();
      if (remember) storage('sessionStorage', 'setItem', 'vt-display-currency', code);
      return;
    }
    status.textContent = lt ? 'Įkeliami valiutų kursai…' : 'Loading reference rates…';
    try {
      await loadRates();
      if (current !== version) return;
      selected = code; select.value = code; render();
      const date = rates.rows.find(row => row.quote === code).date;
      status.textContent = lt ? `ECB orientacinis kursas: ${date}. Atsiskaitymas EUR.` : `ECB reference rate: ${date}. Checkout charged in EUR.`;
      if (remember) storage('sessionStorage', 'setItem', 'vt-display-currency', code);
    } catch (_) {
      if (current !== version) return;
      selected = 'EUR'; select.value = 'EUR'; render();
      if (remember) storage('sessionStorage', 'setItem', 'vt-display-currency', 'EUR');
      status.textContent = lt ? 'Kursai nepasiekiami. Kainos rodomos EUR.' : 'Conversion unavailable. Prices shown in EUR.';
    }
  }
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; render(); });
  }).observe(document.body, {childList:true, subtree:true});
  select.addEventListener('change', () => change(select.value, true));
  setInterval(() => { if (selected !== 'EUR') render(); }, 60000);
  widget.hidden = false;
  change(storage('sessionStorage', 'getItem', 'vt-display-currency') || 'EUR');
})();
